<script>
export default {
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    gap: {
      type: Number,
      default: 0
    }
  }
}
</script>

<template>
  <component
    class="base-flex-column"
    :is="tag"
    :style="{ gap: `${gap / 16}rem` }"
  >
    <slot />
  </component>
</template>

<style lang="scss" scoped>
.base-flex-column {
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/base/base-flex-column.vue